module.exports = __webpack_public_path__ + "static/img/login_bg.0eee3113.jpg";